import PropTypes from "prop-types";
import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Drawer, useMediaQuery } from "@mui/material";
import DrawerHeader from "./DrawerHeader";
import DrawerContent from "./DrawerContent";
import MiniDrawerStyled from "./MiniDrawerStyled";
import { DRAWER_WIDTH } from "config";

const MainDrawer = ({ open, handleDrawerToggle, window }) => {
  const theme = useTheme();
  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  const container =
    window !== undefined ? () => window().document.body : undefined;

  const drawerContent = useMemo(() => <DrawerContent open={open} />, [open]); // Pass open state to DrawerContent
  const drawerHeader = useMemo(() => (
    <DrawerHeader open={open} setOpen={handleDrawerToggle} />
  ), [open, handleDrawerToggle]);

  return (
    <div style={{ backgroundColor: "#0000" }}>
      <Box
        component="nav"
        sx={{ flexShrink: { md: 0 }, zIndex: 1200 }}
        aria-label="mailbox folders"
      >
        {!downLG ? (
          <MiniDrawerStyled
            variant="permanent"
            open={open}
          >
            {drawerHeader}
            {drawerContent}
          </MiniDrawerStyled>
        ) : (
          <Drawer
            container={container}
            variant="temporary"
            open={open}
            onClose={handleDrawerToggle}
            ModalProps={{ keepMounted: true }}
            sx={{
              display: { xs: "block", lg: "none" },
              backgroundColor: "#000000",
              "& .MuiDrawer-paper": {
                boxSizing: "border-box",
                width: DRAWER_WIDTH,
                background: "#ffffff",
                borderRight: "1px solid #e8e8e8",
                boxShadow: "none",
              },
            }}
          >
            {drawerHeader}
            {drawerContent}
          </Drawer>
        )}
      </Box>
    </div>
  );
};

MainDrawer.propTypes = {
  open: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  window: PropTypes.object,
};

export default MainDrawer;
